import * as React from 'react';
import * as classNames from 'classnames';
import { UserProfileFormError } from './UserProfileFormError';
import { FormRow } from '../../Forms/FormRow';
import { Input } from '../../Forms/Input';
import { Label } from '../../Forms/Label';
import uniqueId from '../../../utils/uniqueId';
import './style.css';

export interface UserProfileFormRowProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label: string;
  inputClassName?: string;
  text?: string;
}

export interface UserProfileFormRowState {
  /* empty */
}

export class UserProfileFormRow extends React.Component<
  UserProfileFormRowProps,
  UserProfileFormRowState
> {
  private fieldId: string = uniqueId('login-form-password');

  render() {
    const { className, error, label } = this.props;

    return (
      <FormRow className={classNames('user-profile-form-row', className)}>
        <div className="user-profile-form-row-content">
          <Label className="user-profile-form-row-label" htmlFor={this.fieldId}>
            {label}
          </Label>
          {this.getRowContent()}
        </div>
        <UserProfileFormError error={error} />
      </FormRow>
    );
  }

  private getRowContent = () => {
    const { children, inputClassName, text } = this.props;
    const inputProps: Partial<UserProfileFormRowProps> = { ...this.props };
    delete inputProps.inputClassName;
    delete inputProps.label;
    delete inputProps.error;

    if (children) {
      return (
        <span
          id={this.fieldId}
          className={classNames(
            'user-profile-form-row-children',
            inputClassName
          )}
        >
          {children}
        </span>
      );
    }

    if (text) {
      return (
        <span
          id={this.fieldId}
          className={classNames('user-profile-form-row-text', inputClassName)}
        >
          {text}
        </span>
      );
    }

    return (
      <Input
        id={this.fieldId}
        {...inputProps}
        className={classNames('user-profile-form-row-input', inputClassName)}
      />
    );
  };
}

export default UserProfileFormRow;



// WEBPACK FOOTER //
// ./src/app/components/UserProfile/UserProfileFormRow/index.tsx